import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

const PHOTO_OPTIONS = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1558002038-1055907df827?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    title: "Option 1 · Serrure cylindrique pro",
    desc: "Serrure haute sécurité en gros plan, lumière dramatique. Très technique.",
    mood: "Technique · Confiance",
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1513107132540-ba20e1ae72cb?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    title: "Option 2 · Poignée de porte moderne",
    desc: "Poignée en laiton sur porte design. Esthétique architecture contemporaine.",
    mood: "Moderne · Épuré",
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1582139329536-e7284fece509?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    title: "Option 3 · Porte blindée / coffre",
    desc: "Porte renforcée style coffre-fort. Rassure sur la solidité et sécurité.",
    mood: "Sécurité · Pro",
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1617152974014-ee80a8beaaab?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    title: "Option 4 · Trousseau de clés pro",
    desc: "Ensemble de clés et outils sur table de travail. Montre le savoir-faire.",
    mood: "Artisanal · Savoir-faire",
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1529078155058-5d716f45d604?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    title: "Option 5 · Ancienne serrure vintage",
    desc: "Serrure ancienne en fer forgé. Ambiance authentique, tradition du métier.",
    mood: "Tradition · Expertise",
  },
];

export default function PhotoChoicePage() {
  return (
    <div className="min-h-screen bg-[#F3F4F6]">
      <div className="bg-[#0A0A0A] text-white py-6">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold hover:text-red-400 transition">
            <ArrowLeft className="w-4 h-4" /> Retour au site
          </Link>
          <div className="font-display font-black text-sm uppercase tracking-[0.2em] text-red-400">
            Choix visuel Hero
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
          — 5 propositions pour votre hero
        </div>
        <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl uppercase leading-[0.95] max-w-3xl">
          Laquelle vous<br />parle le plus ?
        </h1>
        <p className="mt-5 text-slate-600 max-w-xl">
          Parcourez les 5 options ci-dessous et dites-moi simplement le numéro (ex : <strong>"option 3"</strong>). Je l'applique en 30 secondes.
        </p>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {PHOTO_OPTIONS.map((p) => (
            <div
              key={p.id}
              data-testid={`photo-option-${p.id}`}
              className="group bg-white border border-black/10 overflow-hidden hover:-translate-y-1 hover:shadow-2xl transition-all"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-slate-200">
                <img
                  src={p.url}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 bg-red-600 text-white font-display font-black px-4 py-2 text-xl shadow-lg">
                  #{p.id}
                </div>
              </div>
              <div className="p-6">
                <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-red-600 mb-2">
                  {p.mood}
                </div>
                <div className="font-display font-black text-xl tracking-tight">{p.title}</div>
                <div className="mt-2 text-sm text-slate-600">{p.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 bg-white border-l-4 border-red-600 p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <CheckCircle2 className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" />
            <div>
              <div className="font-display font-black text-lg">Comment choisir ?</div>
              <div className="text-slate-600 mt-2">
                Écrivez-moi simplement <strong>"option 1"</strong>, <strong>"option 3"</strong>, etc.
                Vous pouvez aussi en combiner 2 (hero + section services) ou me demander d'autres styles.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
